import { RequestPasswordResetPage } from '@/pages/request-password-reset';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/request-password-reset')({
	component: RequestPasswordResetPage,
	validateSearch: (search) => {
		if (search?.email) {
			return { email: search.email as string };
		}
		return {};
	},
});
